import React, { useEffect } from 'react';
import { Col, Alert } from 'antd';
import { useDispatch } from 'react-redux';
// import PropTypes from 'prop-types';
import moment from 'moment';
import io from 'socket.io-client';

import '../../css/custom.css';
import { useLocation } from 'react-router-dom';
import { Content } from 'antd/es/layout/layout';
// import 'antd/dist/antd.css'; // eslint-disable-line

import english from '../../Translations/English.json';
import hindi from '../../Translations/Hindi.json';
import malayalam from '../../Translations/Malayalam.json';

const WaitingRoom = () => {
    const dispatch = useDispatch();

    const { state } = useLocation();

    const langid = localStorage.getItem('INTL') ? (localStorage.getItem('INTL')) : 'en';
    const langdata = langid && langid == 'en' ? english : langid == 'ma' ? malayalam : langid == 'hin' ? hindi : english;

    useEffect(() => {
        dispatch({ type: 'CHECK_PATIENT_PROFILE_EXIST' });
        localStorage.setItem('PATHCLICKED', '/waitingroom');

        // eslint-disable-next-line no-undef
        const socket = io(process.env.REACT_APP_API_BASE_URL, {
            path: '/ws',
            transports: ['websocket'],
        });

        socket.on('connect', (data) => {
            console.log('connect', data);
        });

        socket.emit('waiting', {
            usertoken: sessionStorage.getItem('jwt'),
            appointmentsId: state && state.data && state.data.id
        });

        socket.on('broadcast', (data) => {
            console.log(data);
        });

        socket.on('disconnect', disconnect);
        socket.on('start', consultationStart);

        // Cleanup function for socket connections when the component unmounts
        return () => {
            socket.off('disconnect', disconnect);
            socket.off('start', consultationStart);
        };
    }, [dispatch]);

    const disconnect = (data) => {
        console.log('disconnected', data);
    };

    const consultationStart = (data) => {
        window.open(data.roomUrl, '_self');
        // dispatch({ type: APPOINTMENT_DETAILS_PATCH_WAITINGROOM });
    };

    let name = 'Doctor name';
    let date = moment().format('DD-MM-YYYY');
    let time = moment().format('hh:mm A');

    if (state && state.data !== null) {
        name = `${state.data.docinitials} ${state.data.docfirstName} ${state.data.doclastName}`;
        date = moment(state.data.date).format('DD-MM-YYYY');
        time = moment(state.data.time, 'hh:mm A').format('hh:mm A');
    }


    return (
        <Content>
            <div>
                <Col span={12} offset={6} style={{ marginTop: 20, marginBottom: 20 }}>
                    <Alert
                        message={`${langdata.Doctorwillletyouinsoon ? langdata.Doctorwillletyouinsoon : 'Doctor will let you in soon' }`}
                        description={`${name} waiting room. You have an appointment on ${date} at ${time}`}
                        type="info"
                        showIcon
                    />
                    <Alert
                        style={{ marginTop: 20 }}
                        message={`${langdata.Pleaseenablepopupblocker ? langdata.Pleaseenablepopupblocker : 'Please enable popup blocker' }`}
                        description={'Please enable popup blocker'}
                        type="error"
                        showIcon
                    />
                </Col>
            </div>
        </Content>
    );
};

// WaitingRoom.propTypes = {
//     dispatch: PropTypes.func,
//     profiles: PropTypes.object,
//     requesting: PropTypes.object,
// };

export default WaitingRoom;
